<script>
  import { t } from '../i18n/index.js';
  import { showScreen } from '../stores/screen.js';
  import { linkInfo, redeemLink } from '../stores/session.js';

  let confirming = $state(false);
  let error = $state(null);

  async function handleConfirm() {
    confirming = true;
    error = null;
    try {
      await redeemLink($linkInfo.code);
      showScreen('camera');
    } catch (e) {
      console.error('Link redeem failed:', e);
      if (e.message === 'link_expired') {
        error = t('link.error.expired');
      } else if (e.message === 'link_not_found') {
        error = t('link.error.notFound');
      } else {
        error = t('link.error.failed');
      }
      confirming = false;
    }
  }
</script>

<div class="screen flex flex-col h-full items-center justify-center p-8">
  <div class="text-center max-w-sm">
    <div class="mb-6">
      <svg class="h-20 w-20 mx-auto text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>

    <h1 class="text-2xl font-bold mb-2">{t('link.confirm.title')}</h1>

    {#if $linkInfo?.recipientName}
      <p class="text-gray-400 mb-4">{$linkInfo.recipientName}</p>
    {/if}

    <p class="text-gray-300 mb-8">{t('link.confirm.description')}</p>

    <button
      onclick={handleConfirm}
      disabled={confirming}
      class="btn-large w-full py-4 bg-blue-600 hover:bg-blue-500 disabled:bg-gray-600 disabled:cursor-not-allowed rounded-xl font-bold text-lg transition-colors"
    >
      {confirming ? t('link.confirm.connecting') : t('link.confirm.button')}
    </button>

    {#if error}
      <p class="text-red-400 mt-4">{error}</p>
    {/if}

    {#if !$linkInfo?.desktopOnline}
      <p class="text-yellow-400 text-sm mt-4">{t('link.confirm.pcOffline')}</p>
    {/if}
  </div>
</div>

<style>
  .screen {
    display: flex;
  }

  .btn-large {
    min-height: 60px;
    font-size: 1.125rem;
  }
</style>
